package com.cybersoftsolution.cybersoftsolutionweb.models.ui


import com.cybersoftsolution.cybersoftsolutionweb.components.toast.MyToastStyle
import com.cybersoftsolution.cybersoftsolutionweb.models.Category
import com.cybersoftsolution.cybersoftsolutionweb.models.Post


data class CreatePostUI(
    var post: Post = Post(),
//    var id: String = "",
//    var title: String = "",
//    var subtitle: String = "",
//    var content: String = "",
//    var image: String = "",
//    var selectedCategory: Category = Category.NoCategory,
//    var popular: Boolean = false,
//    var favorite: Boolean = false,
//    var visible: Boolean = true,

    var useImageFromUrl : Boolean = false,
    var editorVisibility: Boolean = true,
    var toastMessage: ToastMessage = ToastMessage(),

)



data class ToastMessage(
    var message: String = "",
    var autoHide: Boolean = true,
    var style: MyToastStyle = MyToastStyle.Info
)